var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscovery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101,
    height: 45,
    viewBox: "0 0 101 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1386",
    "data-name": "Grupo 1386",
    transform: "translate(-103 -443)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1376",
    "data-name": "Grupo 1376",
    transform: "translate(103 443)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_568",
    "data-name": "Rect\\xE1ngulo 568",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 45,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 100,
    height: 44,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Discover-logo",
    transform: "translate(104 457.591)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_000000ff",
    "data-name": "#000000ff"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5261",
    "data-name": "Trazado 5261",
    d: "M417.4,263.322a8.423,8.423,0,0,1,6.069-1.922,8.135,8.135,0,0,1,3.072.939c-.01,1.192,0,2.384-.006,3.576a5.71,5.71,0,0,0-2.717-1.636,5.019,5.019,0,0,0-3.871.732,5.337,5.337,0,0,0-2.277,3.864,5.638,5.638,0,0,0,1.278,4.342,4.977,4.977,0,0,0,3.053,1.61,4.743,4.743,0,0,0,2.977-.443,6.519,6.519,0,0,0,1.556-1.2v3.588a8.537,8.537,0,0,1-3.763.9,8.343,8.343,0,0,1-4.867-1.489,7.969,7.969,0,0,1-2.971-3.958,8.361,8.361,0,0,1-.182-4.72A8.091,8.091,0,0,1,417.4,263.322Z",
    transform: "translate(-384.344 -261.372)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5262",
    "data-name": "Trazado 5262",
    d: "M283.774,262.612a6.845,6.845,0,0,1,5.64,1.605c-.484.732-1.059,1.4-1.579,2.111a3.663,3.663,0,0,0-1.727-1.175,2.829,2.829,0,0,0-2.407.457,1.514,1.514,0,0,0-.518,1.619,1.741,1.741,0,0,0,.9.913c.859.464,1.806.721,2.692,1.125a5.957,5.957,0,0,1,2.558,1.847,5.2,5.2,0,0,1-1.278,6.547,6.218,6.218,0,0,1-8.86-1.9c.668-.612,1.3-1.263,1.966-1.879a3.7,3.7,0,0,0,2.138,1.9,2.971,2.971,0,0,0,2.719-.324,2.074,2.074,0,0,0,.465-2.79,3.423,3.423,0,0,0-1.6-1.005,13.6,13.6,0,0,1-3.59-1.683,3.238,3.238,0,0,1-1.2-1.889,4.625,4.625,0,0,1,.471-3.284,4.69,4.69,0,0,1,3.205-2.19Z",
    transform: "translate(-260.77 -262.409)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5263",
    "data-name": "Trazado 5263",
    d: "M1182.1,264.094a1.2,1.2,0,1,1-.875,1.163,1.2,1.2,0,0,1,.875-1.163m-.082.267a1,1,0,0,0-.037,1.766.967.967,0,1,0,.037-1.766Z",
    transform: "translate(-1084.623 -263.814)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5264",
    "data-name": "Trazado 5264",
    d: "M66.666,265.526h4.357a10.012,10.012,0,0,1,3.132.447A7.428,7.428,0,0,1,79.5,273.28a7.8,7.8,0,0,1-1.692,4.881,7.645,7.645,0,0,1-3.671,2.547,10.142,10.142,0,0,1-3.106.406H66.665V265.523m3.04,2.651v10.289a8.994,8.994,0,0,0,3.958-.549,4.885,4.885,0,0,0,2.553-3.339,5.39,5.39,0,0,0-.62-4.043,4.625,4.625,0,0,0-2.561-2.054,10.686,10.686,0,0,0-3.329-.3Z",
    transform: "translate(-66.665 -265.164)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5265",
    "data-name": "Trazado 5265",
    d: "M230.833,265.529h3.04c.056.821-.036,1.643.013,2.465v13.122q-1.528.008-3.056,0Q230.832,273.322,230.833,265.529Z",
    transform: "translate(-216.603 -265.166)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5266",
    "data-name": "Trazado 5266",
    d: "M745.26,265.479c1.1-.011,2.211,0,3.316-.009,1.4,3.479,2.768,6.968,4.154,10.451,1.428-3.47,2.808-6.962,4.211-10.443,1.1-.005,2.2,0,3.306,0-2.234,5.325-4.493,10.641-6.716,15.971a10.408,10.408,0,0,1-1.676,0C749.668,276.121,747.456,270.8,745.26,265.479Z",
    transform: "translate(-686.443 -265.114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5267",
    "data-name": "Trazado 5267",
    d: "M933.9,265.525c2.878-.011,5.756,0,8.635-.005,0,.884.005,1.768,0,2.652-1.858-.01-3.717.015-5.574-.016-.011,1.154,0,2.308,0,3.462h4.668c.224.037.533-.09.706.08.01.856,0,1.714,0,2.571-1.792.005-3.584,0-5.375,0-.007,1.4,0,2.794,0,4.192,1.862.01,3.724-.015,5.586.012-.009.879,0,1.759-.005,2.638h-8.633Q933.9,273.316,933.9,265.525Z",
    transform: "translate(-858.733 -265.159)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5268",
    "data-name": "Trazado 5268",
    d: "M1056.64,265.526h4.715a6.385,6.385,0,0,1,3.674,1.049,4.006,4.006,0,0,1,1.582,2.709,5,5,0,0,1-.791,3.691,4.4,4.4,0,0,1-2.683,1.572c1.6,2.206,3.266,4.371,4.89,6.563-1.247.009-2.495,0-3.742,0-1.4-2.083-2.808-4.155-4.19-6.247-.142,0-.283,0-.423.006.019,2.078-.005,4.158.011,6.236-1.014.012-2.029,0-3.044,0V265.518m3.041,2.451v4.722a5.061,5.061,0,0,0,2.976-.522,2.332,2.332,0,0,0,.842-2.351,1.937,1.937,0,0,0-1.1-1.5,6.111,6.111,0,0,0-2.718-.341Z",
    transform: "translate(-970.837 -265.163)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5269",
    "data-name": "Trazado 5269",
    d: "M1189.23,270.066c.309.021.777-.108.933.253a.441.441,0,0,1-.25.567c.141.185.3.361.419.561l-.4-.022c-.12-.166-.237-.335-.349-.5-.006.17-.01.34-.012.511l-.336.008v-1.373m.346.231v.394l.28-.088v-.227Z",
    transform: "translate(-1091.932 -269.306)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_ee7824ff",
    "data-name": "#ee7824ff",
    transform: "translate(43.028 0.326)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5270",
    "data-name": "Trazado 5270",
    d: "M568.843,265.56a8.345,8.345,0,0,1,5.275.005,10.381,10.381,0,0,1,.976.392,8.439,8.439,0,0,1,3,2.482,8.271,8.271,0,0,1-4.56,12.97,8.952,8.952,0,0,1-2.781.226,8.193,8.193,0,0,1-4.042-1.476,8.3,8.3,0,0,1-3.242-4.724,8.948,8.948,0,0,1-.218-2.863,8.279,8.279,0,0,1,5.59-7.015Z",
    transform: "translate(-563.219 -265.135)",
    fill: "#ee7824"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscovery);
export default __webpack_public_path__ + "static/media/discovery.0585db6c890b3cd50a73c2ca1e31ddc5.svg";
export { ForwardRef as ReactComponent };